import styled from 'styled-components';
import { Button } from '../../components/utils/Button/Button';
import { Text14Regular, Text28ExtraBold } from '../../components/utils/Text/Text.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-inline: 1.6rem;
  height: 100%;
  text-align: center;
`;

export const StyledButton = styled(Button)`
  width: 16.4rem;
  border-radius: 100px;
  margin-top: 2.4rem;
`;

export const Title = styled(Text28ExtraBold)`
  margin-bottom: 1.2rem;
`;

export const Subtitle = styled(Text14Regular)`
  opacity: 0.67;
  margin-bottom: 10rem;
`;

export const Logo = styled.img`
  width: 11.6rem;
  margin-bottom: 3.8rem;
`;
